import { JackpotEQLevels, JackpotLevelIndexMap } from 'game-ui-types'
import React from 'react'
import { useJackpotStore } from '@stores/jackpotStore'
import { useConfigurationStore } from '@stores/configurationStore'
import { useFormatMoney } from '@hooks'

interface JackpotEQBetSetStatisticsItem {
    betGroupIndex: number
    jackpotEQLevel: JackpotEQLevels
}

const jackpotEQLevelGradient: Record<JackpotEQLevels, string> = {
    PLATINUM: 'linear-gradient(90deg, #B1B1B1 0.28%, #FFFFFF 50.07%, #B1B1B1 99.86%)',
    GOLD: 'linear-gradient(90deg, #BCA703 0%, #FEE880 40%, #FFFBE6 49.56%, #FEE880 60.06%, #BCA703 100%)',
    SILVER: 'linear-gradient(90deg, #A1A1A1 0%, #DDDDDD 50%, #A1A1A1 100%)',
    BRONZE: 'linear-gradient(90deg, #BC560C 0%, #FFCAA4 50%, #BC560C 100%), linear-gradient(90deg, #B1B1B1 0.28%, #FFFFFF 50.07%, #B1B1B1 99.86%)',
}

const JackpotEQBetSetStatisticsItem: React.FC<JackpotEQBetSetStatisticsItem> = ({ betGroupIndex, jackpotEQLevel }) => {
    const schemaBalances = useJackpotStore((state) => state.jackpotEQStatistics?.egyptQuest?.schemaBalances)
    const currencyHideCents = useConfigurationStore((state) => state.currencyHideCents)
    const currencyHideCentsOnlyInJackpotBoxes = useJackpotStore((state) => state.currencyHideCentsOnlyInJackpotBoxes)
    const formatMoney = useFormatMoney()

    const jackpotIndex = JackpotLevelIndexMap[jackpotEQLevel]
    const amount = schemaBalances?.[betGroupIndex].balances[jackpotIndex] ?? -1

    return (
        <div className="rounded-md bg-black shadow-lg overflow-hidden m-[5px]">
            <div
                className="h-[8px]"
                style={{
                    background: jackpotEQLevelGradient[jackpotEQLevel],
                }}
            />

            <div className="px-4 flex justify-center items-center">
                <span className="text-white text-center font-roboto text-[24px] font-bold leading-[24px] whitespace-nowrap">
                    {formatMoney(amount, currencyHideCents || currencyHideCentsOnlyInJackpotBoxes)}
                </span>
            </div>
        </div>
    )
}

export default JackpotEQBetSetStatisticsItem
